export default __webpack_public_path__ + "86652571de689b27674fe539d69900d3.svg";